import components from './components'
import computed from './computed'
import mounted from './mounted'
import methods from './methods'
import data from './data'

export default {
  data,
  components,
  computed,
  mounted,
  methods
}



// WEBPACK FOOTER //
// ./src/app/professional/dashboard/company/gadget/resources/index.js